<template>
  <div class="top-investors-chart">
    <EChartsVerticalBar
      :labels="labels"
      :dataset="dataset"
      :isLoading="isLoading"
      :height="chartHeight"
      labelColor="#000000"
      yAxisName="Млрд $"
      :yAxisMaxRatio="1.1"
      :barMaxWidth="40"
      :formatValueFunction="formatValue"
      :legendSelectable="false"
      :showTooltip="false"
      :titleConfig="chartTitleConfig"
      :emptyMessage="statusMessage"
    />
  </div>
</template>

<script>
  import Constants from '@/common/constants';
  import { numberFormatterWithFixedFractionDigits } from '@/common/utils/numberFormatter';

  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';

  import Api from '../../api';

  const SERVER_UNAVAILABLE_MESSAGE = 'Сервер недоступен';
  const EMPTY_MESSAGE = 'Нет данных для отображения';
  const ERROR_MESSAGES = {
    400: 'Проверьте выбранные фильтры',
    404: 'Ошибка отображения данных',
    500: SERVER_UNAVAILABLE_MESSAGE,
  };

  export default {
    name: 'TopInvestorsChart',
    components: { EChartsVerticalBar },
    props: {
      countryId: {
        type: String,
        default: '',
      },
      year: {
        type: [Number, String],
        default: null,
      },
      countryAccusative: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isLoading: false,
        errorStatus: null,
        investmentData: [],
        chartHeight: 450,
      };
    },
    computed: {
      chartTitleConfig() {
        return {
          text: `Топ-5 стран-инвесторов в ${this.countryAccusative || '—'}, накопленные ПИИ, млрд $`,
        };
      },
      labels() {
        return this.investmentData.map((item) => item.countryName);
      },
      dataset() {
        return [
          {
            label: 'Накопленные ПИИ',
            data: this.investmentData.map((item) => item.amount / Constants.THOUSAND),
            color: '#040086',
          },
        ];
      },
      statusMessage() {
        if (this.isLoading) return '';
        if (this.errorStatus != null) return ERROR_MESSAGES[this.errorStatus] ?? SERVER_UNAVAILABLE_MESSAGE;
        if (!this.investmentData.length) return EMPTY_MESSAGE;
        return '';
      },
    },
    created() {
      this.loadChart();
    },
    methods: {
      async loadChart() {
        if (!this.countryId) return;
        this.isLoading = true;
        this.errorStatus = null;
        try {
          const response = await Api.getTopDirectInwardInvestors(this.countryId, this.year);
          const payload = response?.data ?? {};
          this.investmentData = payload.investmentData ?? [];
        } catch (error) {
          this.errorStatus = error?.response?.status ?? null;
          this.investmentData = [];
        } finally {
          this.isLoading = false;
        }
      },
      formatValue(value) {
        return numberFormatterWithFixedFractionDigits(value, 'ru-RU', 1);
      },
    },
    watch: {
      countryId() {
        this.loadChart();
      },
      year() {
        this.loadChart();
      },
    },
  };
</script>

<style scoped lang="scss">
  .top-investors-chart {
    display: block;
    margin-top: 40px;

    &__title {
      margin-bottom: 16px;
      font-family: 'Fira Sans', sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 18px;
      color: #333333;
    }

    &__message {
      display: flex;
      align-items: center;
      justify-content: center;
      font: $fira-14;
      color: $dark-grey-1;
    }
  }
</style>
